module.exports = __webpack_public_path__ + "8ef9bc444be780f44c9f384a56bbbe0f.pdf";